/*
 * Copyright (c) Nexign, JSC, 2024.
 */
/**
 *
 *
 * @author Ilya Baranchikov
 * @version 1.29.0
 * @since 1.29.0
 */

import { useState } from 'react';

import { Collapse, Typography, useSplitForCollapse } from '@nexign/scc-ui-kit';
import { useSelector } from 'react-redux';

import { ColorLink } from '@/main/theme/default/colors/palette';

import { infoTranslationSelector } from '../selectors';
import { IInfoTariffDiscount } from '../types';
import { SubscriberIdInfoDiscountGroupStyled } from './styled/SubscriberIdInfoStyled';
import { mapDiscountToComponent } from './utils/mapDiscountToComponent';

type TSubscriberIdInfoDiscountGroupProps = {
    discounts?: IInfoTariffDiscount[];
    titleTranslation: string;
    splitLimit?: number;
};

export const SubscriberIdInfoDiscountGroup = ({
    discounts,
    titleTranslation,
    splitLimit = 3,
}: TSubscriberIdInfoDiscountGroupProps) => {
    const { tariffDiscounts: tTariffDiscounts } = useSelector(infoTranslationSelector());

    const [initialDiscounts, restDiscounts] = useSplitForCollapse<IInfoTariffDiscount>(discounts, splitLimit);

    const [isCollapseOpen, setIsCollapseOpen] = useState<boolean>(false);

    return (
        <SubscriberIdInfoDiscountGroupStyled>
            <div className="subscriber-id__title subscriber-id__title_light">{titleTranslation}</div>
            <div>
                {initialDiscounts.map((discount, index) => mapDiscountToComponent(discount, index, tTariffDiscounts))}
                {!!restDiscounts.length && (
                    <Collapse
                        existButton
                        collapseText={<Typography color={ColorLink}>{tTariffDiscounts.showShort}</Typography>}
                        expandText={<Typography color={ColorLink}>{tTariffDiscounts.showAll}</Typography>}
                        isOpen={isCollapseOpen}
                        onClick={() => setIsCollapseOpen((prev) => !prev)}
                    >
                        {restDiscounts.map((discount, index) =>
                            mapDiscountToComponent(discount, index, tTariffDiscounts),
                        )}
                    </Collapse>
                )}
            </div>
        </SubscriberIdInfoDiscountGroupStyled>
    );
};
